import { render, staticRenderFns } from "./ChannelPreviewModal.vue?vue&type=template&id=710da5c7&"
import script from "./ChannelPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelPreviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports